import categoryConfig from "@/config/listeningCategory.json";

// 1~3단계: 8개, 4~5단계: 7개, 6단계: 6개, 7단계: 7개, 8단계: 6개, 9단계: 5개, 10단계: 8개
const LISTENING_CATEGORIES_PER_LEVEL = [8, 8, 8, 7, 7, 6, 7, 6, 5, 8];

function getLevelByCategoryIndex(index) {
  if (index < 0) {
    return 0;
  }

  let cursor = 0;
  for (let level = 0; level < LISTENING_CATEGORIES_PER_LEVEL.length; level++) {
    const size = LISTENING_CATEGORIES_PER_LEVEL[level];
    if (index < cursor + size) {
      return level + 1;
    }
    cursor += size;
  }

  return 0;
}

export function getListeningCategoryLevelNumber(name) {
  const index = categoryConfig.categories.indexOf(name);
  return getLevelByCategoryIndex(index);
}

export function getListeningCategoryDisplayName(name) {
  const levelNumber = getListeningCategoryLevelNumber(name);
  return levelNumber ? `Lv.${levelNumber} ${name}` : name;
}

export function getUniqueListeningCategories() {
  return [...categoryConfig.categories];
}
